// extracted by mini-css-extract-plugin
export default {"NameTag":"NameBlock_NameTag__oPZLY","FrontName":"NameBlock_FrontName__rOiSm","Name":"NameBlock_Name__YF4NP","jump":"NameBlock_jump__MgTbQ","Line":"NameBlock_Line__MmySw"};